// filepath: /my-react-app/my-react-app/src/services/AppConfigService.ts
import { AppConfig } from './AppConfig';
import { EnvService } from './EnvService';
import { ENV_KEYS } from './EnvConstants';

export class AppConfigService {
    private static instance: AppConfigService;
    private config: AppConfig | null = null;

    public static getInstance(): AppConfigService {
        if (!AppConfigService.instance) {
            AppConfigService.instance = new AppConfigService();
        }
        return AppConfigService.instance;
    }

    public getConfig(): AppConfig {
        if (!this.config) {
            this.loadConfig();
        }
        return this.config!;
    }

    private loadConfig(): void {
        const envService = EnvService.getInstance();
        const geminiApiKey = envService.get(ENV_KEYS.GEMINI_API_KEY) || '';
        const geminiApiUrl = envService.get(ENV_KEYS.GEMINI_API_URL) || '';
        const denoApiUrl = envService.get(ENV_KEYS.DENO_API_URL) || '';
        const webAppUrl = envService.get(ENV_KEYS.WEB_APP_URL) || '';

        this.config = {
            geminiApiKey: geminiApiKey,
            geminiApiUrl: geminiApiUrl,
            denoApiUrl: denoApiUrl,
            webAppUrl: webAppUrl,
        };

        this.validateConfig();
    }

    private validateConfig(): void {
    }
}

// Export a default instance
export const appConfigService = AppConfigService.getInstance();